import {
  ResponsiveContainer,
  Tooltip,
  LabelList,
  PieChart,
  Pie,
  BarChart,
  Legend,
  Bar,
  XAxis,
  YAxis,
  Cell,
} from "recharts";
import { CSVLink } from "react-csv";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { Paper, CircularProgress } from "@mui/material";
import { useState, useEffect } from "react";
import FleetStatusTable from "./FleetStatusTable";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import FleetWebApi from "../Api/FleetWebApi";
import FleetOverviewChart from "./FleetOverviewChart";
import { isInOnlineArchive } from "./OnlineArchiveWarning";
import Moment from "react-moment";
function FleetFwChart(props) {
  const [renderList, setRenderList] = useState(false);
  const [list, setList] = useState(null);
  const [firmware, setFirmware] = useState(null);
  const [firmwareSelected, setFirmwareSelected] = useState(false);
  const [revToShow, setRevToShow] = useState(null);
  const [graphData, setGraphData] = useState({});
  const [chartType, setChartType] = useState("Bar");
  const [revGraphData, setRevGraphData] = useState({});
  const [totalDeviceCount, setTotalDeviceCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [timestamp, setTimestamp] = useState(null);
  const COLORS = [
    "#fc853f",
    "#072b8b",
    "#EC32C5",
    "#00b3ff",
    "#cf1111",
    "#280033",
  ];

  const handleChartChange = (event) => {
    setChartType(event.target.value);
  };

  var tooltip;
  const CustomTooltip = ({ active, payload }) => {
    if (!active || !tooltip) return null;
    for (const bar of payload) {
      if (bar.dataKey === tooltip)
        return (
          <div>
            {bar.payload._id}
            <br />
            {bar.value}
            <br />
            {((bar.value / totalDeviceCount) * 100).toFixed(2) + "%"}
          </div>
        );
    }
    return null;
  };

  const handleFirmwareClick = (obj) => {
    setRevToShow(null);
    setFirmware(obj.firmware);
    setFirmwareSelected(true);
  };
  const handleRevClick = (obj) => {
    setFirmware(null);
    setFirmwareSelected(false);
    setRevToShow(obj.rev);
  };
  const handleBackButton = () => {
    setRenderList(null);
    setFirmware(null);
    setFirmwareSelected(false);
    setList(null);
    setRevToShow(null);
  };
  useEffect(() => {
    if (firmwareSelected) {
      setLoading(true);
      // Fetch all devices that are running this firmware
      // An archived report only reaches this chart after the user confirmed the archive prompt
      FleetWebApi.getFleetStatusReportDeviceList(
        Math.floor(new Date(props.reportDate).getTime() / 1000),
        props.deviceType,
        firmware,
        "firmware",
        isInOnlineArchive(props.reportDate)
      )
        .then((response) => {
          setList(response);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    }
  }, [firmware, firmwareSelected]);

  useEffect(() => {
    if (revToShow !== null) {
      setLoading(true);
      // Fetch all devices with this revision
      FleetWebApi.getFleetStatusReportDeviceList(
        Math.floor(new Date(props.reportDate).getTime() / 1000),
        props.deviceType,
        revToShow,
        "rev",
        isInOnlineArchive(props.reportDate)
      )
        .then((response) => {
          setList(response);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [revToShow]);

  useEffect(() => {
    if (list !== null && revToShow !== "ALL") {
      setRenderList(true);
    }
  }, [list]);

  // Main UseEffect
  useEffect(() => {
    setTotalDeviceCount(
      props.data.fw_data.reduce((sum, p) => sum + p.count, 0)
    );
    setGraphData(props.data.fw_data);
    // Sort revs alphabetically (numeric-aware so "10" follows "9"); missing revs go last
    setRevGraphData(
      [...(props.data.rev_data || [])].sort((a, b) => {
        if (a.rev == null) return 1;
        if (b.rev == null) return -1;
        return String(a.rev).localeCompare(String(b.rev), undefined, {
          numeric: true,
          sensitivity: "base",
        });
      })
    );
    setTimestamp(props.reportDate);
  }, [props.data.fw_data, props.data.rev_data]);

  let CsvDownloadLink;
  CsvDownloadLink = list ? (
    <CSVLink
      data={list}
      filename={firmware + "_" + revToShow + "_.csv"}
      onClick={
        revToShow === "ALL"
          ? () => {
              handleBackButton();
            }
          : null
      }
    >
      Download CSV
    </CSVLink>
  ) : null;

  if (loading) {
    return (
      <div>
        <CircularProgress color="secondary" />
      </div>
    );
  }
  if (renderList) {
    return (
      <div>
        <Button
          variant="contained"
          color="secondary"
          label="Back"
          style={{ marginLeft: 5, marginRight: 5 }}
          onClick={() => {
            handleBackButton();
          }}
        >
          Back to Overview
        </Button>
        {CsvDownloadLink}
        <FleetStatusTable data={list} />
      </div>
    );
  }
  return (
    <div>
      <br />
      {timestamp ? (
        <Moment format="YYYY-MM-DD HH:mm:ss Z">{timestamp}</Moment>
      ) : null}
      {/* <FleetOverviewChart reportType={props.deviceType} /> */}
      <br />
      <br />

      <Container maxWidth="lg" key={"container"}>
        <Grid
          container
          spacing={3}
          key={"menuGrid"}
          justifyContent={"space-between"}
        >
          <Grid item lg={3} key={"gridItemChartMenu"}>
            {graphData && (
              <Box sx={{ maxWidth: 120 }}>
                <FormControl fullWidth>
                  <InputLabel id="chart-select-label">Chart Type</InputLabel>
                  <Select
                    labelId="chart-select-label"
                    id="chart-select"
                    value={chartType}
                    label="chartType"
                    onChange={handleChartChange}
                  >
                    <MenuItem value={"Bar"}>Bar</MenuItem>
                    <MenuItem value={"Pie"}>Pie</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            )}
          </Grid>
          <Grid item lg={3} key={"gridItemListButton"}>
            <Button
              variant="contained"
              color="secondary"
              label="Back"
              onClick={() => {
                setRevToShow("ALL");
              }}
            >
              Get a list of all devices
            </Button>
          </Grid>
          <Grid item lg={3} key={"gridItemDownloadLink"}>
            {CsvDownloadLink}
          </Grid>
        </Grid>

        <div key={"div"}>
          <div key={"div1"} style={{ clear: "both" }}>
            <h3 style={{ float: "left", paddingRight: "5px" }} key={"title"}>
              {"FW spread"}
            </h3>
            <h3
              style={{ float: "right", paddingRight: "5px" }}
              key={"totalcount"}
            >
              {"Total Count : " + totalDeviceCount}
            </h3>
          </div>
          {/* <Container maxWidth="lg" key={keyIndex + "container"}> */}
          <Grid container spacing={2} key={"grid"}>
            <Grid item xs={12} key={"gridItem"}>
              <Paper key={"paper"}>
                {chartType === "Pie" && (
                  <ResponsiveContainer
                    width="100%"
                    height={500}
                    key={"respContainer"}
                  >
                    <PieChart width="100%" height="100%">
                      <Pie
                        data={graphData}
                        innerRadius={60}
                        paddingAngle={2}
                        onClick={(e) => handleFirmwareClick(e)}
                        dataKey="count"
                        onMouseOver={() => (tooltip = "count")}
                      >
                        {graphData.map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={COLORS[index % COLORS.length]}
                          />
                        ))}
                      </Pie>
                      <Tooltip
                        content={<CustomTooltip key={"customtippie"} />}
                        key={"ToolTipPie"}
                      />
                    </PieChart>
                  </ResponsiveContainer>
                )}
                {chartType === "Bar" && (
                  <ResponsiveContainer
                    width="100%"
                    height={500}
                    key={"respContainer"}
                  >
                    <BarChart
                      width="100%"
                      height="100%"
                      data={graphData}
                      margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                      }}
                      onClick={(e) =>
                        e?.activePayload?.[0] &&
                        handleFirmwareClick(e.activePayload[0].payload)
                      }
                      onMouseOver={() => (tooltip = "count")}
                    >
                      <XAxis
                        dataKey="firmware"
                        tickFormatter={(v) => v ?? "Unknown"}
                      />
                      <YAxis />
                      <Tooltip
                        content={<CustomTooltip key={"customtipbar"} />}
                        key={"ToolTipbar"}
                      />
                      <Legend />
                      <Bar dataKey="count" fill="#fc853f" key={"Bar"}>
                        <LabelList
                          dataKey="firmware"
                          position="bottom"
                          angle={270}
                          offset={-200}
                          formatter={(v) => v ?? "Unknown"}
                        />
                      </Bar>
                    </BarChart>
                  </ResponsiveContainer>
                )}
              </Paper>
              {chartType === "Bar" ? (
                <div key={"Revdiv"}>
                  <h3 key={"Revtitle"}>{" Rev spread"}</h3>
                  <Paper>
                    <ResponsiveContainer
                      width="100%"
                      height={500}
                      key={"respContainerREV"}
                    >
                      <BarChart
                        width="100%"
                        height="100%"
                        data={revGraphData}
                        margin={{
                          top: 5,
                          right: 30,
                          left: 20,
                          bottom: 5,
                        }}
                        onClick={(e) =>
                          e?.activePayload?.[0] &&
                          handleRevClick(e.activePayload[0].payload)
                        }
                      >
                        <XAxis dataKey="rev" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="count" fill="#fd5e53" key={"BarREV"} />
                      </BarChart>
                    </ResponsiveContainer>
                  </Paper>
                </div>
              ) : null}
            </Grid>
          </Grid>
        </div>
      </Container>
    </div>
  );
}

export default FleetFwChart;
